<template>
  <validation-provider
    v-slot="{ errors }"
    mode="eager"
    :name="tag.description"
    :rules="tag.custom_settings.validation || ''"
  >
    <div ref="refcontrolcontainer" class="pb-4">
      <v-text-field
        :id="`form-image-ext-editor-${tag.name}`"
        v-resize="onResize"
        :value="storageFix"
        :label="tag.description"
        outlined
        readonly
        dense
        clearable
        class="fm-text-field"
        :hide-details="errors.length == 0"
        :error-messages="errors"
        @click="fmOpen"
        @click:clear="fmReset"
      >
        <template v-slot:append>
          <div class="d-flex">
            <v-icon @click="fmOpen">mdi-image-search-outline</v-icon>
            <uploader-button
              :work-dir="workDir"
              class="d-block"
              @upload-success="onImageUpload"
              @upload-error="onUploadError"
            >
              <v-icon>mdi-upload</v-icon>
            </uploader-button>
          </div>
        </template>
      </v-text-field>
      <image-ext
        v-if="hasImage"
        v-model="imageAssets"
        :src="fullImagePath"
        :image-padding="18"
      />
      <file-manager-dialog
        v-model="fmDialog"
        src="imageeditor"
        :selected-path="storageFix"
        :work-dir="workDir"
        :allowed-extensions="['jpg', 'jpeg', 'png', 'svg', 'gif']"
        @fm-select="fmSelect"
        @fm-close="fmClose"
      />
    </div>
  </validation-provider>
</template>

<script>
import ImageExt from "@/components/ImageExt.vue";
import FileManagerDialog from "./FileManagerDialog/FileManagerDialog.vue";
import UploaderButton from "../../../components/UploaderButton.vue";

export default {
  components: {
    FileManagerDialog,
    ImageExt,
    UploaderButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    tag: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fmDialog: false,
      imageWidth: 450,
      imageHeight: 300
    };
  },
  computed: {
    imageAssets: {
      get() {
        const contain = this.value ? this.value.i_contain || "0" : "0";
        const defBackground = this.$store.getters.getDefaultBackground;
        const fill = this.value
          ? this.value.i_fill || defBackground
          : defBackground;
        const left = this.value?.i_left || null;
        const top = this.value?.i_top || null;
        const right = this.value?.i_right || null;
        const bottom = this.value?.i_bottom || null;
        return { contain, fill, left, top, right, bottom };
      },
      set(val) {
        const data = {
          i_main: this.value.i_main,
          i_contain: val.contain,
          i_fill: val.fill,
          i_left: val.left,
          i_top: val.top,
          i_right: val.right,
          i_bottom: val.bottom
        };
        this.$emit("input", data);
      }
    },
    workDir() {
      return this.tag?.custom_settings?.images_dir || "/images";
    },
    storageFix() {
      return (this.value?.i_main || "").replace("<STORAGE>", "");
    },
    hasImage() {
      return (this.value?.i_main?.length || 0) > 0;
    },
    fullImagePath() {
      return (this.value?.i_main || "").replace(
        "<STORAGE>",
        this.$store.getters.getStoragePrefix
      );
    }
  },

  methods: {
    fmOpen() {
      this.fmDialog = true;
    },
    fmClose() {
      this.fmDialog = false;
    },
    fmReset() {
      this.$emit("input", {});
    },
    fmSelect(file) {
      this.fmDialog = false;
      let newValue = file;
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.imageAssets.i_main = `<STORAGE>${newValue}`;
      this.$emit("input", this.imageAssets);
    },
    onResize() {
      const el = this.$refs.refcontrolcontainer;
      const rect = el.getBoundingClientRect();
      this.imageWidth = rect.width;
      this.imageHeight = rect.width * 0.66;
    },
    onImageUpload(files) {
      let newValue = files[0];
      if (!newValue.startsWith("/")) newValue = `/${newValue}`;
      this.imageAssets.i_main = `<STORAGE>${newValue}`;
      this.$emit("input", this.imageAssets);
    },
    onUploadError(error) {
      this.$store.commit("addNotice", {
        type: "error",
        message: error
      });
    }
  }
};
</script>
